import React from 'react'
import { Block, Image } from '@components'

const DatoCmsImage = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      gutters
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <Image elevated {...props} />
    </Block>
  )
}

export default DatoCmsImage
